import { ApiTablePageView } from 'components/ApiTablePage/ApiTablePageView';
import {
  type ApiTablePageHookProps,
  useApiTablePage,
} from 'components/ApiTablePage/useApiTablePage';
import type { FC } from 'react';

type Props = ApiTablePageHookProps & { tableClassName?: string };

export const ApiTablePage: FC<Props> = ({ tableClassName, ...props }) => {
  const apiTablePage = useApiTablePage(props);
  return (
    <ApiTablePageView model={apiTablePage} tableClassName={tableClassName} />
  );
};
